import { Box, Stack, Typography } from '@offline-mui/material'
import type { ReactNode } from 'react'

type EmptyStateProps = {
  icon?: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  compact?: boolean
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <Stack
      spacing={1.5}
      sx={{
        alignItems: 'center',
        textAlign: 'center',
        py: compact ? 4 : 7,
        px: 3,
      }}
    >
      {icon ? (
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'grey.100',
            color: 'grey.400',
            '& svg': { fontSize: 28 },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Typography variant="subtitle1">{title}</Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440 }}>
          {description}
        </Typography>
      ) : null}
      {action ? <Box sx={{ pt: 0.5 }}>{action}</Box> : null}
    </Stack>
  )
}
